import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ArrowAltTopLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "m12 6 .354-.354L12 5.293l-.354.353zm-.5 12a.5.5 0 0 0 1 0zm4.854-8.354-4-4-.708.708 4 4zm-4.708-4-4 4 .708.708 4-4zM11.5 6v12h1V6z" })));
}
const ArrowAltTopLight = forwardRef(_ArrowAltTopLight);
export { ArrowAltTopLight };
